import { SetContextLink } from '@apollo/client/link/context';

import { toBearer } from '@/api/session';
import { getUserToken } from '@/shared/services/user-hash';

/**
 * Подставляет bearer-токен сотрудника из куки в каждый HTTP-запрос. Токен
 * читается заново при каждом проходе — повтор после refresh уходит с новым.
 */
export const authLink = new SetContextLink((prevContext) => {
  const { accessToken } = getUserToken();
  if (!accessToken) return {};

  return {
    headers: {
      ...prevContext.headers,
      Authorization: toBearer(accessToken)
    }
  };
});
